module.exports = __webpack_public_path__ + "static/media/stripeIcon.5eb5ea0b.svg";